import { FirestoreService } from "../../../../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../../api/firebase/references";
import { updateCPTtables } from "../../../../../api/postCall/updateCPTtables";
import { DraftSubmissionFormData } from "../../../../../components/modals/draftSubmissionModal/hooks/useDraftSubmissionFormDataWithErrorStates";
import { AuthStatusOptionModel } from "../../../../../data-model/authStatusOptions";
import { CptCodesTableRowModel } from "../../../../../data-model/cptCodesTableModel";
import { DraftSubmission } from "../../../../../data-model/draftSubmission";
import {
  JCodeDetails,
  MedicalPaOrder,
} from "../../../../../data-model/medicalPaOrdersModel";
import { PortalConfig } from "../../../../../data-model/portalConfigForDraftSubmission";
import { UpdateJCodeDataModel } from "../../../../../data-model/updateJCodeModel";
import { LocalStorageKeys } from "../../../../../enums/localStorageKeys";
import { closeModal } from "../../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../../redux/store/store";
import { removeItemFromLocalStorage } from "../../../../../utils/localStorageHelper";
import {
  generateDraftSubmissionPayloadOnSave,
  generateUpdateJCodePayloadOnSave,
} from "../utils/generatePayloadsForDraftSubmissions";

const handleDraftSubmissionOnSave = async (
  orderId: string,
  draftSubmissionPayload: DraftSubmission,
  updateJCodePayload: UpdateJCodeDataModel,
  setState: React.Dispatch<React.SetStateAction<boolean>>,
  dispatch: AppDispatch,
) => {
  try {
    setState(true);
    await FirestoreService.addDocumentWithId(
      FirestoreCollectionReference.draftSubmission(orderId),

      draftSubmissionPayload,
    );
    await updateCPTtables(updateJCodePayload);
    removeItemFromLocalStorage(`${LocalStorageKeys.CPT_CODES}_${orderId}`);
    dispatch(closeModal());
  } catch (error) {
    console.error(error);
  } finally {
    setState(false);
  }
};

export const triggerDraftSubmissionOnSave = async (
  orderId: string,
  formData: DraftSubmissionFormData,
  jCodes: JCodeDetails[],
  portalConfigData: PortalConfig[],
  singleMedicalPaOrder: MedicalPaOrder,
  setState: React.Dispatch<React.SetStateAction<boolean>>,
  dispatch: AppDispatch,
  tableData: CptCodesTableRowModel[],
  authStatusOptions: AuthStatusOptionModel[],
) => {
  const draftSubmissionPayload = generateDraftSubmissionPayloadOnSave(
    formData,
    jCodes,
    portalConfigData,
    singleMedicalPaOrder,
  );
  const updateJCodePayload = generateUpdateJCodePayloadOnSave(
    formData,
    singleMedicalPaOrder.id ?? "",
    tableData,
    authStatusOptions,
  );
  await handleDraftSubmissionOnSave(
    orderId,
    draftSubmissionPayload,
    updateJCodePayload,
    setState,
    dispatch,
  );
};
